export default class InputFilter {

    constructor(input) {
        this.input = input;
        this.options = input.find('option[value!=""]');
    }

    clear() {
        this.input.val('');
    }

    change(fn) {
        this.input.change(fn);
    }

    disable() {
        this.input.prop('disabled', true);
    }

    enable() {
        this.input.prop('disabled', false);
    }

    val(value) {
        if (value === null || value === undefined) {
            return this.input.val();
        }
        this.input.val(value);
    }

    data(key) {
        return this.options.filter(':selected').data(key);
    }

    items(filter) {
        if (filter) {
            return this.input.find(`option${filter}`);
        } else {
            return this.input.find(`option`);
        }
    }

    detachOptions() {
        this.options.detach();
    }

    appendOptions(selector) {
        const filterOptions = this.options.filter(selector);     
        filterOptions.appendTo(this.input);
        if (this.input[0].length > 2) {            
            this.options.filter(`[data-all=true]`).appendTo(this.input);
        }
    }

    sortOptions(byText = false) {
        let sortedOptions = this.input.find('option[value!=""][data-all!=true]');
        sortedOptions.sort(function (a, b) {
            let aVal;
            let bVal;
            if (byText) {
                aVal = $(a).text();
                bVal = $(b).text();
            } else {
                aVal = $(a).val();
                bVal = $(b).val();
            }
            return (aVal > bVal) ? 1 : ((aVal < bVal) ? -1 : 0);
        })
        sortedOptions.detach().appendTo(this.input);
        if (this.input[0].length > 2) {
            this.options.filter(`[data-all=true]`).appendTo(this.input);
        }
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Filters/InputFilter.js